module.exports = __webpack_public_path__ + "static/img/banner-6.726926d.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/banner-6.png
// module id = LYzw
// module chunks = 0